import type { ModuleInput, ModuleOutput } from "@/lib/types/module"
import { DataType } from "@/lib/types/module"

const TOKEN_REGEX = /\{\{(\w+)\}\}/g

/** Parse unique {{variable}} tokens from a template string, preserving order */
export function parseTemplateVariables(template: string): string[] {
  const seen = new Set<string>()
  const vars: string[] = []
  for (const match of template.matchAll(TOKEN_REGEX)) {
    const name = match[1]
    if (!seen.has(name)) {
      seen.add(name)
      vars.push(name)
    }
  }
  return vars
}

/** Build dynamic ModuleInput handles for text_builder from its template */
export function getTextBuilderInputs(template: string): ModuleInput[] {
  return parseTemplateVariables(template).map((name) => ({
    name,
    type: DataType.String,
    required: false,
    handle: true,
    description: `Value for {{${name}}}`,
  }))
}

export interface OutputSchemaField {
  _id?: string
  name: string
  type: "string" | "number" | "boolean"
}

const SCHEMA_TYPE_TO_DATA_TYPE: Record<OutputSchemaField["type"], DataType> = {
  string: DataType.String,
  number: DataType.Number,
  boolean: DataType.Boolean,
}

/** Build dynamic output handles for llm_text from its output_schema config. */
export function getStructuredOutputHandles(
  schema: OutputSchemaField[],
): ModuleOutput[] {
  const seen = new Set<string>()
  return schema
    .filter((f) => f.name && !seen.has(f.name) && seen.add(f.name))
    .map((f) => ({
      name: f.name,
      type: SCHEMA_TYPE_TO_DATA_TYPE[f.type] ?? DataType.String,
      handle: true,
      description: f.name,
    }))
}
